<script>
    import Modal from "./Modal.svelte";
    import { _ } from "svelte-i18n";
    import * as store from "../stores";
    import DocListItem from "./DocListItem.svelte";
    import Icon from "fa-svelte";
    import { faTimes } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";

    export let value;
    export let collection;
    export let form;
    export let multiple = false;

    const dispatch = createEventDispatcher();

    let opened = false;

    $: docStore = store[collection];
    $: docs = $docStore;
    $: selectedValues = multiple ? value : [value];
    $: selectedDocs = getSelectedDocs(selectedValues, docs);
    $: selectedSet = new Set(selectedDocs.map(({ uid }) => uid));

    const getSelectedDocs = (values, docs) => {
        if (!docs) return [];
        return values
            .map((value) => docs.find(({ uid }) => uid === value))
            .filter((it) => it);
    };

    const handleRemove = (uid) => {
        if (!value) return null;
        if (typeof value === "string") return (value = "");
        value = value.filter((it) => it !== uid);
    };

    const handleDocClick = (uid) => {
        if (selectedDocs.find(({ uid: doc }) => doc === uid)) {
            handleRemove(uid);
        } else if (multiple) {
            value = [...value, uid];
        } else {
            value = uid;
        }
        dispatch("change");
        if (multiple) return;
        opened = false;
    };
</script>

<style>
    .rounded-xl {
        max-width: 15em;
    }
</style>

<Modal bind:opened>
    <div class="flex justify-end">
        <div class="cursor-pointer" on:click={() => (opened = false)}>
            <Icon icon={faTimes} />
        </div>
    </div>
    <div class="grid p-4 grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4">
        {#each docs as doc}
            <div class:cursor-pointer={!multiple}>
                <DocListItem
                    selected={selectedSet.has(doc.uid)}
                    {form}
                    {doc}
                    on:click={() => handleDocClick(doc.uid)} />
            </div>
        {/each}
    </div>
</Modal>

<div class="grid p-4 grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4">
    {#each selectedDocs as doc}
        <div on:click={() => (multiple ? null : (opened = true))}>
            <DocListItem {form} {doc} />
        </div>
    {/each}

    {#if multiple || !selectedDocs.length}
        <div
            on:click={() => (opened = true)}
            class="cursor-pointer rounded-xl overflow-hidden
        flex flex-col items-center justify-center h-64
        bg-gray-200 border-gray-500 border text-gray-600">
            <h4>{$_('Choose')}</h4>
        </div>
    {/if}
</div>
